<div class="page">
  <div class="page__header">
    <div class="page__header__title">
      <i class="material-icons">headset_mic</i>
      <label translate>nav.task</label>
    </div>

    <div class="page__header__tab">
      <a
        [class.selected]="isActiveRoute('/task/client')"
        [routerLink]="['client']"
      >
        <div class="menu-title" translate>nav.user</div>
      </a>

      <a
        [class.selected]="isActiveRoute('/task/builtin')"
        [routerLink]="['builtin']"
      >
        <div class="menu-title" translate>nav.builtin</div>
      </a>
    </div>
  </div>

  <router-outlet></router-outlet>
</div>
